export default __webpack_public_path__ + "static/media/src_repairapp_desk_6.2632515f.jpg";